{
    "name": "k",
    "actionTrace": [
        {
            "type": "invoke skill",
            "skillKey": "inflict-damage",
            "performerKey": "hero",
            "position": {
                "x": 6,
                "y": 4,
                "z": 1
            },
            "performerPosition": {
                "x": 6,
                "y": 5,
                "z": 1
            },
            "deltastageSum": {
                "units": {
                    "hero": {
                        "key": "hero",
                        "position": {
                            "mode": "absolute",
                            "x": 6,
                            "y": 5,
                            "z": 1
                        },
                        "equippedItem": {
                            "name": "Axe",
                            "element": "earth",
                            "attacktype": "steel",
                            "attackrange": 1,
                            "power": 20,
                            "skillKeys": [
                                "inflict-damage"
                            ],
                            "weaponImageKey": "ember-axe"
                        },
                        "energy": {
                            "move": false,
                            "invoke skill": false
                        }
                    },
                    "newUnit2": {
                        "key": "newUnit2",
                        "health": 0,
                        "position": {
                            "mode": "absolute",
                            "x": 6,
                            "y": 4,
                            "z": 1
                        },
                        "state": "aggroed",
                        "opacity": 0,
                        "isDead": true
                    }
                },
                "type": "particle",
                "text": {
                    "string": "-30",
                    "font": "numbers"
                },
                "opacity": 0,
                "flags": {
                    "tutorial:hasAttacked": true,
                    "tutorial:hasAttackedBlueWithBlue": true,
                    "tutorial:AttackerColor": "green",
                    "tutorial:AttackedColor": "green",
                    "newUnit2_here": false,
                    "tutorial:hasKilled": true
                }
            }
        },
        {
            "type": "invoke skill",
            "skillKey": "interact",
            "performerKey": "firekeeper",
            "position": {
                "x": 7,
                "y": 6,
                "z": 1
            },
            "performerPosition": {
                "x": 8,
                "y": 6,
                "z": 1
            },
            "deltastageSum": {
                "units": {
                    "firekeeper": {
                        "key": "firekeeper",
                        "position": {
                            "mode": "absolute",
                            "x": 8,
                            "y": 6,
                            "z": 1
                        },
                        "inventory": {
                            "count": null,
                            "items": {
                                "32175": {
                                    "key": "32175",
                                    "name": "Squash",
                                    "image": "./kiwisquash-VZZQPXSS.png"
                                }
                            }
                        },
                        "energy": {
                            "move": false,
                            "invoke skill": false
                        }
                    },
                    "newUnit14": {
                        "key": "newUnit14",
                        "health": 0,
                        "inventory": {
                            "count": null,
                            "items": {}
                        },
                        "opacity": 0,
                        "isDead": true
                    }
                },
                "flags": {
                    "tutorial:hasLooted": true,
                    "newUnit14_here": false,
                    "tutorial:hasKilled": true
                },
                "type": "particle",
                "image": "./kiwisquash-VZZQPXSS.png",
                "opacity": 0
            }
        },
        {
            "type": "invoke skill",
            "skillKey": "rally",
            "performerKey": "swordbard",
            "position": {
                "x": 8,
                "y": 6,
                "z": 1
            },
            "performerPosition": {
                "x": 8,
                "y": 5,
                "z": 1
            },
            "deltastageSum": {
                "units": {
                    "swordbard": {
                        "key": "swordbard",
                        "position": {
                            "mode": "absolute",
                            "x": 8,
                            "y": 5,
                            "z": 1
                        },
                        "energy": {
                            "move": false,
                            "invoke skill": false
                        }
                    },
                    "firekeeper": {
                        "key": "firekeeper",
                        "energy": {
                            "move": true,
                            "invoke skill": true
                        },
                        "position": {
                            "mode": "absolute",
                            "x": 8,
                            "y": 6,
                            "z": 1
                        }
                    }
                },
                "flags": {
                    "tutorial:hasRallied": true
                }
            }
        },
        {
            "type": "invoke skill",
            "skillKey": "swap",
            "performerKey": "firekeeper",
            "position": {
                "x": 8,
                "y": 3,
                "z": 1
            },
            "performerPosition": {
                "x": 8,
                "y": 3,
                "z": 1
            },
            "deltastageSum": {
                "units": {
                    "firekeeper": {
                        "key": "firekeeper",
                        "position": {
                            "mode": "absolute",
                            "x": 8,
                            "y": 3,
                            "z": 1
                        },
                        "energy": {
                            "move": false,
                            "invoke skill": false
                        }
                    },
                    "newUnit1": {
                        "key": "newUnit1",
                        "position": {
                            "mode": "absolute",
                            "x": 8,
                            "y": 4,
                            "z": 1
                        }
                    }
                }
            }
        },
        {
            "type": "undoAction"
        },
        {
            "type": "undoAction"
        },
        {
            "type": "invoke skill",
            "skillKey": "rally",
            "performerKey": "swordbard",
            "position": {
                "x": 8,
                "y": 6,
                "z": 1
            },
            "performerPosition": {
                "x": 9,
                "y": 6,
                "z": 1
            },
            "deltastageSum": {
                "units": {
                    "swordbard": {
                        "key": "swordbard",
                        "position": {
                            "mode": "absolute",
                            "x": 9,
                            "y": 6,
                            "z": 1
                        },
                        "energy": {
                            "move": false,
                            "invoke skill": false
                        }
                    },
                    "firekeeper": {
                        "key": "firekeeper",
                        "energy": {
                            "move": true,
                            "invoke skill": true
                        },
                        "position": {
                            "mode": "absolute",
                            "x": 8,
                            "y": 6,
                            "z": 1
                        }
                    }
                },
                "flags": {
                    "tutorial:hasRallied": true
                }
            }
        },
        {
            "type": "invoke skill",
            "skillKey": "inflict-damage",
            "performerKey": "firekeeper",
            "position": {
                "x": 8,
                "y": 3,
                "z": 1
            },
            "performerPosition": {
                "x": 8,
                "y": 5,
                "z": 1
            },
            "deltastageSum": {
                "units": {
                    "firekeeper": {
                        "key": "firekeeper",
                        "position": {
                            "mode": "absolute",
                            "x": 8,
                            "y": 5,
                            "z": 1
                        },
                        "equippedItem": {
                            "name": "Staff",
                            "element": "earth",
                            "attacktype": "magic",
                            "attackrange": 2,
                            "power": 20,
                            "skillKeys": [
                                "inflict-damage"
                            ],
                            "weaponImageKey": "ember-green-staff"
                        },
                        "energy": {
                            "move": false,
                            "invoke skill": false
                        }
                    },
                    "newUnit1": {
                        "key": "newUnit1",
                        "health": 5,
                        "position": {
                            "mode": "absolute",
                            "x": 8,
                            "y": 3,
                            "z": 1
                        },
                        "state": "aggroed"
                    }
                },
                "type": "particle",
                "text": {
                    "string": "-20",
                    "font": "numbers"
                },
                "opacity": 0,
                "flags": {
                    "tutorial:hasAttackedWithoutCounterattack": true,
                    "tutorial:hasAttackedBlueWithBlue": true,
                    "tutorial:AttackerColor": "green",
                    "tutorial:AttackedColor": "green"
                }
            }
        },
        {
            "type": "undoAction"
        },
        {
            "type": "undoAction"
        },
        {
            "type": "move",
            "performerKey": "swordbard",
            "position": {
                "x": 8,
                "y": 5,
                "z": 1
            },
            "performerPosition": {
                "x": 8,
                "y": 5,
                "z": 1
            },
            "distance": 2,
            "deltastageSum": {
                "units": {
                    "swordbard": {
                        "key": "swordbard",
                        "position": {
                            "mode": "absolute",
                            "x": 8,
                            "y": 5,
                            "z": 1
                        },
                        "energy": {
                            "move": false
                        }
                    }
                }
            }
        },
        {
            "type": "invoke skill",
            "skillKey": "rally",
            "performerKey": "swordbard",
            "position": {
                "x": 8,
                "y": 6,
                "z": 1
            },
            "performerPosition": {
                "x": 8,
                "y": 5,
                "z": 1
            },
            "deltastageSum": {
                "units": {
                    "swordbard": {
                        "key": "swordbard",
                        "position": {
                            "mode": "absolute",
                            "x": 8,
                            "y": 5,
                            "z": 1
                        },
                        "energy": {
                            "move": false,
                            "invoke skill": false
                        }
                    },
                    "firekeeper": {
                        "key": "firekeeper",
                        "energy": {
                            "move": true,
                            "invoke skill": true
                        },
                        "position": {
                            "mode": "absolute",
                            "x": 8,
                            "y": 6,
                            "z": 1
                        }
                    }
                },
                "flags": {
                    "tutorial:hasRallied": true
                }
            }
        },
        {
            "type": "invoke skill",
            "skillKey": "interact",
            "performerKey": "firekeeper",
            "position": {
                "x": 7,
                "y": 4,
                "z": 1
            },
            "performerPosition": {
                "x": 7,
                "y": 5,
                "z": 1
            },
            "deltastageSum": {
                "units": {
                    "firekeeper": {
                        "key": "firekeeper",
                        "position": {
                            "mode": "absolute",
                            "x": 7,
                            "y": 5,
                            "z": 1
                        },
                        "energy": {
                            "move": false,
                            "invoke skill": false
                        }
                    },
                    "newUnit24": {
                        "intent": "flame",
                        "spriteSize": "4x3",
                        "imageKey": "ember-flame",
                        "isHidingHealthbar": true,
                        "health": 30,
                        "maxhealth": 30,
                        "deathTimer": 2,
                        "position": {
                            "mode": "absolute",
                            "x": 7,
                            "y": 4,
                            "z": 1
                        },
                        "key": "newUnit24"
                    }
                }
            }
        }
    ],
    "deltastageSum": {
        "flags": {
            "hero_here": true,
            "firekeeper_here": true,
            "swordbard_here": true,
            "tutorial:hasAttacked": true,
            "tutorial:hasAttackedBlueWithBlue": true,
            "tutorial:AttackerColor": "green",
            "tutorial:AttackedColor": "green",
            "newUnit2_here": false,
            "tutorial:hasKilled": true,
            "tutorial:hasLooted": true,
            "newUnit14_here": false,
            "tutorial:hasRallied": true,
            "tutorial:hasAttackedWithoutCounterattack": true
        },
        "units": {
            "hero": {
                "key": "hero",
                "name": "Kullervo",
                "jobName": "The Hero",
                "affiliation": "good",
                "isRecruited": true,
                "hasSlowDeath": true,
                "jobKey": "hammer",
                "maxhealth": 80,
                "power": 10,
                "defense": 3,
                "primaryItem": {
                    "name": "Axe",
                    "element": "earth",
                    "attacktype": "steel",
                    "attackrange": 1,
                    "power": 20,
                    "skillKeys": [
                        "inflict-damage"
                    ],
                    "weaponImageKey": "ember-axe"
                },
                "secondaryItem": {
                    "name": "Bow",
                    "element": "water",
                    "attacktype": "steel",
                    "attackrange": 2,
                    "power": 20,
                    "skillKeys": [
                        "inflict-damage"
                    ],
                    "weaponImageKey": "ember-bow"
                },
                "skillKeys": [
                    "push",
                    "interact"
                ],
                "dialogue": {
                    "death": [
                        {
                            "isIgnorable": true
                        },
                        "THE HERO HAS TAKEN A FATAL HIT",
                        "HERO: ..."
                    ],
                    "slowdeath": [
                        "HERO: Not yet, not yet.."
                    ]
                },
                "spriteSize": "4x3",
                "sprites": {
                    "static": "./sprites-kullervo-static-KP2CXKJG.png"
                },
                "portraits": {
                    "neutral": "./portraits-ember-kullervo-radiance-BRCZL2MX.png"
                },
                "position": {
                    "mode": "absolute",
                    "x": 6,
                    "y": 5,
                    "z": 1
                },
                "spawnspot": {
                    "position": {
                        "x": 6,
                        "y": 7,
                        "z": 1
                    },
                    "key": "BSB33",
                    "tag": "goodspawn"
                },
                "equippedItem": {
                    "name": "Axe",
                    "element": "earth",
                    "attacktype": "steel",
                    "attackrange": 1,
                    "power": 20,
                    "skillKeys": [
                        "inflict-damage"
                    ],
                    "weaponImageKey": "ember-axe"
                },
                "energy": {
                    "move": false,
                    "invoke skill": false
                }
            },
            "firekeeper": {
                "key": "firekeeper",
                "jobName": "The Firekeeper",
                "name": "Mara",
                "affiliation": "good",
                "isRecruited": true,
                "hasSlowDeath": true,
                "jobKey": "shaman",
                "maxhealth": 40,
                "defense": 3,
                "primaryItem": {
                    "name": "Staff",
                    "element": "earth",
                    "attacktype": "magic",
                    "attackrange": 2,
                    "power": 20,
                    "skillKeys": [
                        "inflict-damage"
                    ],
                    "weaponImageKey": "ember-green-staff"
                },
                "secondaryItem": {
                    "name": "Daggers",
                    "attackrange": 2,
                    "power": 20,
                    "element": "fire",
                    "attacktype": "steel",
                    "skillKeys": [
                        "inflict-damage"
                    ],
                    "weaponImageKey": "ember-daggers"
                },
                "skillKeys": [
                    "swap",
                    "interact"
                ],
                "dialogue": {
                    "death": [
                        {
                            "isIgnorable": true
                        },
                        "THE FIREKEEPER HAS TAKEN A FATAL HIT",
                        "FIREKEEPER: ..."
                    ],
                    "slowdeath": [
                        "FIREKEEPER: The hearthlands are real.",
                        "FIREKEEPER: I will not reach them with you.",
                        "FIREKEEPER: But know they are real, and they are warm."
                    ]
                },
                "spriteSize": "4x3",
                "sprites": {
                    "static": "./sprites-mara-static-YJMXH2ZM.png"
                },
                "portraits": {
                    "neutral": "./portraits-ember-mara-R7LWPRSQ.png"
                },
                "position": {
                    "mode": "absolute",
                    "x": 7,
                    "y": 5,
                    "z": 1
                },
                "spawnspot": {
                    "position": {
                        "x": 7,
                        "y": 7,
                        "z": 1
                    },
                    "key": "tOXD0",
                    "tag": "goodspawn"
                },
                "inventory": {
                    "count": null,
                    "items": {
                        "32175": {
                            "key": "32175",
                            "name": "Squash",
                            "image": "./kiwisquash-VZZQPXSS.png"
                        }
                    }
                },
                "energy": {
                    "move": false,
                    "invoke skill": false
                },
                "equippedItem": {
                    "name": "Staff",
                    "element": "earth",
                    "attacktype": "magic",
                    "attackrange": 2,
                    "power": 20,
                    "skillKeys": [
                        "inflict-damage"
                    ],
                    "weaponImageKey": "ember-green-staff"
                }
            },
            "swordbard": {
                "key": "swordbard",
                "name": "Ashe",
                "jobName": "The Swordbard",
                "affiliation": "good",
                "isRecruited": true,
                "hasSlowDeath": true,
                "jobKey": "sword",
                "maxhealth": 40,
                "defense": 3,
                "primaryItem": {
                    "name": "Sword",
                    "element": "fire",
                    "attacktype": "steel",
                    "attackrange": 1,
                    "power": 20,
                    "skillKeys": [
                        "inflict-damage"
                    ],
                    "weaponImageKey": "ember-sword"
                },
                "tertiaryItem": {
                    "key": "torch",
                    "name": "Torch",
                    "element": "fire",
                    "weaponImageKey": "ember-torch"
                },
                "skillKeys": [
                    "rally",
                    "interact"
                ],
                "dialogue": {
                    "death": [
                        {
                            "isIgnorable": true
                        },
                        "THE SWORDBARD HAS TAKEN A FATAL HIT.",
                        "SWORDBARD: Think nothing of it~ I will not fall!! Charge!!!"
                    ],
                    "slowdeath": [
                        "SWORDBARD: Please forgive me."
                    ]
                },
                "spriteSize": "4x3",
                "sprites": {
                    "static": "./sprites-ashe-static-IDUHM6VX.png"
                },
                "portraits": {
                    "neutral": "./portraits-ember-ashe-happy-YSKMXZ7A.png"
                },
                "position": {
                    "mode": "absolute",
                    "x": 8,
                    "y": 5,
                    "z": 1
                },
                "spawnspot": {
                    "position": {
                        "x": 8,
                        "y": 7,
                        "z": 1
                    },
                    "key": "dXbM8",
                    "tag": "goodspawn"
                },
                "energy": {
                    "move": false,
                    "invoke skill": false
                }
            },
            "newUnit0": {
                "affiliation": "bad",
                "title": "???",
                "subtitle": "Monstrosity",
                "jobKey": "spear",
                "spriteSize": "4x3",
                "imageKey": "ember-wolf-blue",
                "weaponImageKey": "hidden",
                "health": 25,
                "maxhealth": 30,
                "position": {
                    "mode": "absolute",
                    "x": 3,
                    "y": 4,
                    "z": 1
                },
                "key": "newUnit0"
            },
            "newUnit1": {
                "affiliation": "bad",
                "title": "???",
                "subtitle": "Monstrosity",
                "jobKey": "axe",
                "spriteSize": "4x3",
                "imageKey": "ember-wolf-green",
                "weaponImageKey": "hidden",
                "health": 5,
                "maxhealth": 30,
                "position": {
                    "mode": "absolute",
                    "x": 8,
                    "y": 3,
                    "z": 1
                },
                "key": "newUnit1",
                "state": "aggroed"
            },
            "newUnit2": {
                "affiliation": "bad",
                "title": "???",
                "subtitle": "Monstrosity",
                "jobKey": "axe",
                "spriteSize": "4x3",
                "imageKey": "ember-wolf-green",
                "weaponImageKey": "hidden",
                "health": 0,
                "maxhealth": 30,
                "position": {
                    "mode": "absolute",
                    "x": 6,
                    "y": 4,
                    "z": 1
                },
                "key": "newUnit2",
                "state": "aggroed",
                "opacity": 0,
                "isDead": true
            },
            "newUnit3": {
                "affiliation": "bad",
                "title": "???",
                "subtitle": "Monstrosity",
                "jobKey": "sword",
                "spriteSize": "4x3",
                "imageKey": "ember-wolf-red",
                "weaponImageKey": "hidden",
                "health": 25,
                "maxhealth": 30,
                "position": {
                    "mode": "absolute",
                    "x": 3,
                    "y": 5,
                    "z": 1
                },
                "key": "newUnit3"
            },
            "newUnit4": {
                "affiliation": "bad",
                "title": "???",
                "subtitle": "Monstrosity",
                "jobKey": "axe",
                "spriteSize": "4x3",
                "imageKey": "ember-wolf-green",
                "weaponImageKey": "hidden",
                "health": 25,
                "maxhealth": 30,
                "position": {
                    "mode": "absolute",
                    "x": 4,
                    "y": 15,
                    "z": 1
                },
                "key": "newUnit4"
            },
            "newUnit5": {
                "affiliation": "bad",
                "title": "???",
                "subtitle": "Monstrosity",
                "jobKey": "sword",
                "spriteSize": "4x3",
                "imageKey": "ember-wolf-red",
                "weaponImageKey": "hidden",
                "health": 25,
                "maxhealth": 30,
                "position": {
                    "mode": "absolute",
                    "x": 10,
                    "y": 14,
                    "z": 1
                },
                "key": "newUnit5"
            },
            "newUnit6": {
                "affiliation": "bad",
                "title": "???",
                "subtitle": "Monstrosity",
                "jobKey": "axe",
                "spriteSize": "4x3",
                "imageKey": "ember-wolf-green",
                "weaponImageKey": "hidden",
                "health": 25,
                "maxhealth": 30,
                "position": {
                    "mode": "absolute",
                    "x": 6,
                    "y": 15,
                    "z": 1
                },
                "key": "newUnit6"
            },
            "newUnit7": {
                "affiliation": "bad",
                "title": "???",
                "subtitle": "Monstrosity",
                "jobKey": "axe",
                "spriteSize": "4x3",
                "imageKey": "ember-wolf-green",
                "weaponImageKey": "hidden",
                "health": 25,
                "maxhealth": 30,
                "position": {
                    "mode": "absolute",
                    "x": 12,
                    "y": 15,
                    "z": 1
                },
                "key": "newUnit7"
            },
            "newUnit8": {
                "affiliation": "bad",
                "title": "???",
                "subtitle": "Monstrosity",
                "jobKey": "sword",
                "spriteSize": "4x3",
                "imageKey": "ember-wolf-red",
                "weaponImageKey": "hidden",
                "health": 25,
                "maxhealth": 30,
                "position": {
                    "mode": "absolute",
                    "x": 12,
                    "y": 22,
                    "z": 1
                },
                "key": "newUnit8"
            },
            "newUnit9": {
                "affiliation": "bad",
                "title": "???",
                "subtitle": "Monstrosity",
                "jobKey": "axe",
                "spriteSize": "4x3",
                "imageKey": "ember-wolf-green",
                "weaponImageKey": "hidden",
                "health": 25,
                "maxhealth": 30,
                "position": {
                    "mode": "absolute",
                    "x": 11,
                    "y": 23,
                    "z": 1
                },
                "key": "newUnit9"
            },
            "newUnit10": {
                "affiliation": "bad",
                "title": "???",
                "subtitle": "Monstrosity",
                "jobKey": "sword",
                "spriteSize": "4x3",
                "imageKey": "ember-wolf-red",
                "weaponImageKey": "hidden",
                "health": 25,
                "maxhealth": 30,
                "position": {
                    "mode": "absolute",
                    "x": 8,
                    "y": 22,
                    "z": 1
                },
                "key": "newUnit10"
            },
            "newUnit11": {
                "affiliation": "bad",
                "title": "???",
                "subtitle": "Monstrosity",
                "jobKey": "sword",
                "spriteSize": "4x3",
                "imageKey": "ember-wolf-red",
                "weaponImageKey": "hidden",
                "health": 25,
                "maxhealth": 30,
                "position": {
                    "mode": "absolute",
                    "x": 5,
                    "y": 23,
                    "z": 1
                },
                "key": "newUnit11"
            },
            "newUnit12": {
                "type": "thing",
                "intent": "loot",
                "title": "Kiwi Squash",
                "subtitle": "Plant",
                "isHidingHealthbar": true,
                "spriteSize": "4x3",
                "imageKey": "plant1",
                "health": 10,
                "maxhealth": 10,
                "position": {
                    "mode": "absolute",
                    "x": 11,
                    "y": 5,
                    "z": 1
                },
                "inventory": {
                    "count": null,
                    "items": {
                        "34507": {
                            "key": "34507",
                            "name": "Squash",
                            "image": "./kiwisquash-VZZQPXSS.png"
                        }
                    }
                },
                "key": "newUnit12"
            },
            "newUnit13": {
                "type": "thing",
                "intent": "loot",
                "title": "Kiwi Squash",
                "subtitle": "Plant",
                "isHidingHealthbar": true,
                "spriteSize": "4x3",
                "imageKey": "plant1",
                "health": 10,
                "maxhealth": 10,
                "position": {
                    "mode": "absolute",
                    "x": 5,
                    "y": 4,
                    "z": 1
                },
                "inventory": {
                    "count": null,
                    "items": {
                        "56421": {
                            "key": "56421",
                            "name": "Squash",
                            "image": "./kiwisquash-VZZQPXSS.png"
                        }
                    }
                },
                "key": "newUnit13"
            },
            "newUnit14": {
                "type": "thing",
                "intent": "loot",
                "title": "Kiwi Squash",
                "subtitle": "Plant",
                "isHidingHealthbar": true,
                "spriteSize": "4x3",
                "imageKey": "plant1",
                "health": 0,
                "maxhealth": 10,
                "position": {
                    "mode": "absolute",
                    "x": 7,
                    "y": 6,
                    "z": 1
                },
                "inventory": {
                    "count": null,
                    "items": {
                        "32175": {
                            "key": "32175",
                            "name": "Squash",
                            "image": "./kiwisquash-VZZQPXSS.png"
                        }
                    }
                },
                "key": "newUnit14",
                "opacity": 0,
                "isDead": true
            },
            "newUnit15": {
                "type": "thing",
                "intent": "loot",
                "title": "Kiwi Squash",
                "subtitle": "Plant",
                "isHidingHealthbar": true,
                "spriteSize": "4x3",
                "imageKey": "plant1",
                "health": 10,
                "maxhealth": 10,
                "position": {
                    "mode": "absolute",
                    "x": 3,
                    "y": 15,
                    "z": 1
                },
                "inventory": {
                    "count": null,
                    "items": {
                        "94846": {
                            "key": "94846",
                            "name": "Squash",
                            "image": "./kiwisquash-VZZQPXSS.png"
                        }
                    }
                },
                "key": "newUnit15"
            },
            "newUnit16": {
                "type": "thing",
                "intent": "loot",
                "title": "Kiwi Squash",
                "subtitle": "Plant",
                "isHidingHealthbar": true,
                "spriteSize": "4x3",
                "imageKey": "plant1",
                "health": 10,
                "maxhealth": 10,
                "position": {
                    "mode": "absolute",
                    "x": 6,
                    "y": 14,
                    "z": 1
                },
                "inventory": {
                    "count": null,
                    "items": {
                        "61297": {
                            "key": "61297",
                            "name": "Squash",
                            "image": "./kiwisquash-VZZQPXSS.png"
                        }
                    }
                },
                "key": "newUnit16"
            },
            "newUnit17": {
                "type": "thing",
                "intent": "loot",
                "title": "Kiwi Squash",
                "subtitle": "Plant",
                "isHidingHealthbar": true,
                "spriteSize": "4x3",
                "imageKey": "plant1",
                "health": 10,
                "maxhealth": 10,
                "position": {
                    "mode": "absolute",
                    "x": 7,
                    "y": 15,
                    "z": 1
                },
                "inventory": {
                    "count": null,
                    "items": {
                        "70273": {
                            "key": "70273",
                            "name": "Squash",
                            "image": "./kiwisquash-VZZQPXSS.png"
                        }
                    }
                },
                "key": "newUnit17"
            },
            "newUnit18": {
                "type": "thing",
                "intent": "loot",
                "title": "Kiwi Squash",
                "subtitle": "Plant",
                "isHidingHealthbar": true,
                "spriteSize": "4x3",
                "imageKey": "plant1",
                "health": 10,
                "maxhealth": 10,
                "position": {
                    "mode": "absolute",
                    "x": 11,
                    "y": 22,
                    "z": 1
                },
                "inventory": {
                    "count": null,
                    "items": {
                        "76820": {
                            "key": "76820",
                            "name": "Squash",
                            "image": "./kiwisquash-VZZQPXSS.png"
                        }
                    }
                },
                "key": "newUnit18"
            },
            "newUnit19": {
                "type": "thing",
                "intent": "loot",
                "title": "Kiwi Squash",
                "subtitle": "Plant",
                "isHidingHealthbar": true,
                "spriteSize": "4x3",
                "imageKey": "plant1",
                "health": 10,
                "maxhealth": 10,
                "position": {
                    "mode": "absolute",
                    "x": 5,
                    "y": 21,
                    "z": 1
                },
                "inventory": {
                    "count": null,
                    "items": {
                        "36598": {
                            "key": "36598",
                            "name": "Squash",
                            "image": "./kiwisquash-VZZQPXSS.png"
                        }
                    }
                },
                "key": "newUnit19"
            },
            "newUnit20": {
                "type": "thing",
                "intent": "loot",
                "title": "Kiwi Squash",
                "subtitle": "Plant",
                "isHidingHealthbar": true,
                "spriteSize": "4x3",
                "imageKey": "plant1",
                "health": 10,
                "maxhealth": 10,
                "position": {
                    "mode": "absolute",
                    "x": 3,
                    "y": 21,
                    "z": 1
                },
                "inventory": {
                    "count": null,
                    "items": {
                        "18055": {
                            "key": "18055",
                            "name": "Squash",
                            "image": "./kiwisquash-VZZQPXSS.png"
                        }
                    }
                },
                "key": "newUnit20"
            },
            "newUnit21": {
                "type": "thing",
                "title": "Beacon",
                "intent": "beacon",
                "isHidingHealthbar": true,
                "spriteSize": "4x3",
                "imageKey": "ember-beacon",
                "health": 100,
                "maxhealth": 100,
                "position": {
                    "mode": "absolute",
                    "x": 7,
                    "y": 4,
                    "z": 1
                },
                "key": "newUnit21"
            },
            "newUnit22": {
                "type": "thing",
                "title": "Beacon",
                "intent": "beacon",
                "isHidingHealthbar": true,
                "spriteSize": "4x3",
                "imageKey": "ember-beacon",
                "health": 100,
                "maxhealth": 100,
                "position": {
                    "mode": "absolute",
                    "x": 9,
                    "y": 15,
                    "z": 1
                },
                "key": "newUnit22"
            },
            "newUnit23": {
                "type": "thing",
                "title": "Beacon",
                "intent": "beacon",
                "isHidingHealthbar": true,
                "spriteSize": "4x3",
                "imageKey": "ember-beacon",
                "health": 100,
                "maxhealth": 100,
                "position": {
                    "mode": "absolute",
                    "x": 10,
                    "y": 23,
                    "z": 1
                },
                "key": "newUnit23"
            },
            "newUnit24": {
                "intent": "flame",
                "spriteSize": "4x3",
                "imageKey": "ember-flame",
                "isHidingHealthbar": true,
                "health": 30,
                "maxhealth": 30,
                "deathTimer": 2,
                "position": {
                    "mode": "absolute",
                    "x": 7,
                    "y": 4,
                    "z": 1
                },
                "key": "newUnit24"
            }
        },
        "type": "particle",
        "text": {
            "string": "-20",
            "font": "numbers"
        },
        "opacity": 0,
        "image": "./kiwisquash-VZZQPXSS.png"
    },
    "sequenceLengthRemaining": 0,
    "chapterSlug": "test",
    "player": {
        "affiliation": "good",
        "inventory": {
            "items": [
                {
                    "name": "Axe"
                },
                {
                    "name": "Gun"
                },
                {
                    "name": "Sword"
                },
                {
                    "name": "Daggers"
                },
                {
                    "name": "Spear"
                },
                {
                    "name": "Bow"
                },
                {
                    "name": "Fire Orb"
                }
            ]
        },
        "party": {
            "units": {
                "hero": {
                    "key": "hero",
                    "name": "Kullervo",
                    "jobName": "The Hero",
                    "affiliation": "good",
                    "isRecruited": true,
                    "hasSlowDeath": true,
                    "jobKey": "hammer",
                    "maxhealth": 80,
                    "power": 10,
                    "defense": 3,
                    "primaryItem": {
                        "name": "Axe",
                        "element": "earth",
                        "attacktype": "steel",
                        "attackrange": 1,
                        "power": 20,
                        "skillKeys": [
                            "inflict-damage"
                        ],
                        "weaponImageKey": "ember-axe"
                    },
                    "secondaryItem": {
                        "name": "Bow",
                        "element": "water",
                        "attacktype": "steel",
                        "attackrange": 2,
                        "power": 20,
                        "skillKeys": [
                            "inflict-damage"
                        ],
                        "weaponImageKey": "ember-bow"
                    },
                    "skillKeys": [
                        "push",
                        "interact"
                    ],
                    "dialogue": {
                        "death": [
                            {
                                "isIgnorable": true
                            },
                            "THE HERO HAS TAKEN A FATAL HIT",
                            "HERO: ..."
                        ],
                        "slowdeath": [
                            "HERO: Not yet, not yet.."
                        ]
                    },
                    "spriteSize": "4x3",
                    "sprites": {
                        "static": "./sprites-kullervo-static-KP2CXKJG.png"
                    },
                    "portraits": {
                        "neutral": "./portraits-ember-kullervo-radiance-BRCZL2MX.png"
                    }
                },
                "firekeeper": {
                    "key": "firekeeper",
                    "jobName": "The Firekeeper",
                    "name": "Mara",
                    "affiliation": "good",
                    "isRecruited": true,
                    "hasSlowDeath": true,
                    "jobKey": "shaman",
                    "maxhealth": 40,
                    "defense": 3,
                    "primaryItem": {
                        "name": "Staff",
                        "element": "earth",
                        "attacktype": "magic",
                        "attackrange": 2,
                        "power": 20,
                        "skillKeys": [
                            "inflict-damage"
                        ],
                        "weaponImageKey": "ember-green-staff"
                    },
                    "secondaryItem": {
                        "name": "Daggers",
                        "attackrange": 2,
                        "power": 20,
                        "element": "fire",
                        "attacktype": "steel",
                        "skillKeys": [
                            "inflict-damage"
                        ],
                        "weaponImageKey": "ember-daggers"
                    },
                    "skillKeys": [
                        "swap",
                        "interact"
                    ],
                    "dialogue": {
                        "death": [
                            {
                                "isIgnorable": true
                            },
                            "THE FIREKEEPER HAS TAKEN A FATAL HIT",
                            "FIREKEEPER: ..."
                        ],
                        "slowdeath": [
                            "FIREKEEPER: The hearthlands are real.",
                            "FIREKEEPER: I will not reach them with you.",
                            "FIREKEEPER: But know they are real, and they are warm."
                        ]
                    },
                    "spriteSize": "4x3",
                    "sprites": {
                        "static": "./sprites-mara-static-YJMXH2ZM.png"
                    },
                    "portraits": {
                        "neutral": "./portraits-ember-mara-R7LWPRSQ.png"
                    }
                },
                "swordbard": {
                    "key": "swordbard",
                    "name": "Ashe",
                    "jobName": "The Swordbard",
                    "affiliation": "good",
                    "isRecruited": true,
                    "hasSlowDeath": true,
                    "jobKey": "sword",
                    "maxhealth": 40,
                    "defense": 3,
                    "primaryItem": {
                        "name": "Sword",
                        "element": "fire",
                        "attacktype": "steel",
                        "attackrange": 1,
                        "power": 20,
                        "skillKeys": [
                            "inflict-damage"
                        ],
                        "weaponImageKey": "ember-sword"
                    },
                    "tertiaryItem": {
                        "key": "torch",
                        "name": "Torch",
                        "element": "fire",
                        "weaponImageKey": "ember-torch"
                    },
                    "skillKeys": [
                        "rally",
                        "interact"
                    ],
                    "dialogue": {
                        "death": [
                            {
                                "isIgnorable": true
                            },
                            "THE SWORDBARD HAS TAKEN A FATAL HIT.",
                            "SWORDBARD: Think nothing of it~ I will not fall!! Charge!!!"
                        ],
                        "slowdeath": [
                            "SWORDBARD: Please forgive me."
                        ]
                    },
                    "spriteSize": "4x3",
                    "sprites": {
                        "static": "./sprites-ashe-static-IDUHM6VX.png"
                    },
                    "portraits": {
                        "neutral": "./portraits-ember-ashe-happy-YSKMXZ7A.png"
                    }
                }
            }
        }
    },
    "gameSlug": "ember",
    "randomSeed": "bPMtGGSwp7REy5EbpkEqG",
    "captureDate": 1747245049240,
    "data": {}
}